// Need Username, githubname, Join date, Bio, Repos count, Followers count, following count, location, twitter handle, Website, company

export const mockData = {
  login: "mattstuddert",
  id: 7057034,
  node_id: "MDQ6VXNlcjcwNTcwMzQ=",
  avatar_url: "https://avatars.githubusercontent.com/u/7057034?v=4",
  gravatar_id: "",
  url: "https://api.github.com/users/mattstuddert",
  html_url: "https://github.com/mattstuddert",
  followers_url: "https://api.github.com/users/mattstuddert/followers",
  following_url:
    "https://api.github.com/users/mattstuddert/following{/other_user}",
  gists_url: "https://api.github.com/users/mattstuddert/gists{/gist_id}",
  starred_url:
    "https://api.github.com/users/mattstuddert/starred{/owner}{/repo}",
  subscriptions_url: "https://api.github.com/users/mattstuddert/subscriptions",
  organizations_url: "https://api.github.com/users/mattstuddert/orgs",
  repos_url: "https://api.github.com/users/mattstuddert/repos",
  events_url: "https://api.github.com/users/mattstuddert/events{/privacy}",
  received_events_url:
    "https://api.github.com/users/mattstuddert/received_events",
  type: "User",
  site_admin: false,
  name: "Matt Studdert",
  company: "@frontendmentorio ",
  blog: "https://www.frontendmentor.io",
  location: "London, UK",
  email: null,
  hireable: null,
  bio: "Front-end/JavaScript developer. Founder of Frontend Mentor.",
  twitter_username: "_mattstuddert",
  public_repos: 5,
  public_gists: 2,
  followers: 115,
  following: 12,
  created_at: "2014-03-25T09:50:47Z",
  updated_at: "2021-12-01T17:05:49Z",
}
